module.exports = __webpack_public_path__ + "static/media/bar8.5fadc8ef.svg";